export class Customer {
  public _id: string;
  public postal: string;
  public street: string;
  public city: string;
  public phonenumber: string;
  public contact: string;
  public contactPhone: string;
  public email: string;
  public notes: string;
  public provision: string;
  public subscription: string;
  public machines: any[];
  public currentMaintenance: any;

  constructor(public name: string) {}
}



// WEBPACK FOOTER //
// ./src/app/models/customer.model.ts